// Reducer

import { FAILURE, REQUEST, SUCCESS } from 'app/shared/util/action-type.util';
import { ACTION_TYPES } from './actions';
import { AuthenticationState, initialState } from './state';

export default (state: AuthenticationState = initialState, action): AuthenticationState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_USER):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_USER): {
      const isAuthenticated = action.payload && action.payload.data && action.payload.data.activated;
      return {
        ...state,
        isAuthenticated,
        loading: false,
        sessionHasBeenFetched: true,
        account: action.payload.data,
      };
    }
    case FAILURE(ACTION_TYPES.GET_USER):
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        sessionHasBeenFetched: true,
        errorMessage: action.payload,
      };

    case REQUEST(ACTION_TYPES.LOGOUT):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.LOGOUT): {
      return {
        ...state,
        idToken: action.payload.data.idToken,
        logoutUrl: action.payload.data.logoutUrl,
      };
    }

    case ACTION_TYPES.ERROR_MESSAGE:
      return {
        ...initialState,
        redirectMessage: action.message,
      };

    case ACTION_TYPES.CLEAR_AUTH: {
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
      };
    }

    case REQUEST(ACTION_TYPES.FIND_SELLING_POINT):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.FIND_SELLING_POINT): {
      return {
        ...state,
        sellingPointModel: action.payload.data,
        loading: false,
      };
    }

    case FAILURE(ACTION_TYPES.FIND_SELLING_POINT): {
      return {
        ...state,
        loading: false,
      };
    }

    default:
      return state;
  }
};
